(function () {

    var KnowledgeTestCertifiedProcessComponent = {
        bindings: {
            hide: '&'
        },
        templateUrl: '../modules/e-verify/components/knowledge-test-certified-process/knowledge-test-certified-process.html',
        controllerAs: 'checkCertifiedProcess',
        controller: [function () {}]
    };

    angular.module('harriApp.eVerify')
        .component('knowledgeTestCertifiedProcess', KnowledgeTestCertifiedProcessComponent);
})();
